export const LOAD_CB_LAZY_TOGGLE = 'eprivacy_load_cb_lazy'
